<script setup lang="ts">
const pathData = [
    'M9.59766 1.87891L12.7207 5.00195L9.59766 1.87891L12.7207 5.00195',
    'C12.9069 5.18815 13 5.41667 13 5.6875C13 5.95833 12.9069 6.18685',
    '12.7207 6.37305L9.59766 9.49609C9.42839 9.66536 9.22526 9.75',
    '8.98828 9.75C8.7513 9.75 8.54818 9.66536 8.37891 9.49609',
    'C8.20964 9.32682 8.125 9.1237 8.125 8.88672V7.3125H4.875',
    'C4.63802 7.3125 4.44336 7.23633 4.29102 7.08398C4.13867 6.93164',
    '4.0625 6.73698 4.0625 6.5V4.875C4.0625 4.63802 4.13867 4.44336',
    '4.29102 4.29102C4.44336 4.13867 4.63802 4.0625 4.875 4.0625H8.125',
    'V2.48828C8.125 2.2513 8.20964 2.04818 8.37891 1.87891C8.54818 1.70964',
    '8.7513 1.625 8.98828 1.625C9.22526 1.625 9.42839 1.70964 9.59766 1.87891Z',
    'M4.0625 1.625H2.4375H4.0625H2.4375C2.20052 1.625 2.00586 1.70117',
    '1.85352 1.85352C1.70117 2.00586 1.625 2.20052 1.625 2.4375V8.9375',
    'C1.625 9.17448 1.70117 9.36914 1.85352 9.52148C2.00586 9.67383',
    '2.20052 9.75 2.4375 9.75H4.0625C4.29948 9.75 4.49414 9.82617',
    '4.64648 9.97852C4.79883 10.1309 4.875 10.3255 4.875 10.5625',
    'C4.875 10.7995 4.79883 10.9941 4.64648 11.1465C4.49414 11.2988',
    '4.29948 11.375 4.0625 11.375H2.4375C1.74349 11.3581 1.16797 11.1211',
    '0.710938 10.6641C0.253906 10.207 0.0169271 9.63151 0 8.9375V2.4375',
    'C0.0169271 1.74349 0.253906 1.16797 0.710938 0.710938C1.16797 0.253906',
    '1.74349 0.0169271 2.4375 0H4.0625C4.29948 0 4.49414 0.0761719',
    '4.64648 0.228516C4.79883 0.380859 4.875 0.575521 4.875 0.8125',
    'C4.875 1.04948 4.79883 1.24414 4.64648 1.39648C4.49414 1.54883',
    '4.29948 1.625 4.0625 1.625Z',
].join(' ');
</script>

<template>
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path :d="pathData" fill="currentColor" />
    </svg>
</template>
